/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';

export abstract class AbstractFileStorageService {
  protected abstract apiEndPoint: string;
  protected abstract http: HttpClient;

  uploadMultiple(files: File[]) {
    const formData: FormData = new FormData();
    files.map((file: File) => {
      formData.append('files', file);
    });
    return this.upload(`${this.apiEndPoint}/uploadMultipleFiles`, formData);
  }

  uploadBlob(blob: Blob, fileName: string) {
    const formData: FormData = new FormData();
    formData.append('files', blob, fileName);
    return this.upload(`${this.apiEndPoint}/uploadMultipleFiles`, formData);
  }

  getFileAsUrlById(id: string | undefined): Observable<string | null> {
    if (!id) {
      return of(null);
    }
    const headers = new HttpHeaders({ 'Content-Type': 'application/octet-stream' });
    return this.http.get(`${this.apiEndPoint}/downloadFile/${id}`, {
      headers,
      responseType: 'blob',
      observe: 'response'
    }).pipe(map(res => res.body ? URL?.createObjectURL(res.body) : null));
  }

  downloadFileById(id: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/octet-stream' });
    this.http.get(`${this.apiEndPoint}/downloadFile/${id}`, {
      headers,
      responseType: 'blob',
      observe: 'response'
    }).subscribe((res) => {
      const contentDisposition = res.headers.get('content-disposition');
      const fileName = contentDisposition?.replace('attachment; filename=', '').replace(/"/g, '');
      const link = document.createElement('a');
      if (res.body) {
        link.href = window.URL?.createObjectURL(res.body);
      }
      if (fileName) {
        link.download = decodeURIComponent(fileName);
      }
      link.click();
    });
  }

  protected upload(url: string, formData: FormData) {
    return this.http.post<any[]>(url, formData);
  }
}
